const Main = (props) => {
  return (
    <main>
      <div className="max-w-7xl mx-auto py-6 sm:px lg:px-8 mt-40">
        {props.children}
      </div>
    </main>
  );
};

export default Main;
